import { Event } from '@/event-bus/event';

export class ColumnResetTriggeredEvent extends Event<void> {}
